import angular from 'angular';
import tickertapeComponent from './tickertape.component';

let tickertapeModule = angular.module('tickertape', [])

.component('tickertape', tickertapeComponent)

.name;

export default tickertapeModule;



// WEBPACK FOOTER //
// ./client/app/components/content-types/tickertape/tickertape.js